import React from 'react'
import Slider from 'components/Slider'

import LegacyRetinaImage from 'components/LegacyRetinaImage'

const Frame = ({ frame, onFrameSelect, isActive }) => {
  const bgcolor = frame.bgColor || '#ffffff'
  const frameSrc =
    frame.image && frame.image.id
      ? `${process.env.SITE_ASSET_URL}/${frame.image.id}`
      : null
  return (
    <li
      className={`frame-option ${isActive ? 'is--active' : 'is--not--active'}`}
      aria-label="frame-option"
    >
      <button
        onClick={() => {
          console.log('onclick')
          onFrameSelect(frame)
        }}
        type="button"
      >
        <div
          className={`image-behind`}
          style={{ backgroundColor: `${bgcolor}` }}
        >
          <img id={frame.image.id} crossOrigin={`anonymous`} src={frameSrc} alt={frame.image.altAttribute ? frame.image.altAttribute : "frame"} />
        </div>
      </button>
    </li>
  )
}

const FrameRow = ({ label, frames = [], onFrameSelect, frameSelected }) => {
  return (
    <div className="frame-row">
      {label && <div className="frame-label">{label}</div>}
      <ul className={`frame-option-list`}>
        {frames &&
          !!frames.length &&
          frames.map((frame, i) => {
            return frame.image ? (
              <Frame
                frame={frame}
                onFrameSelect={onFrameSelect}
                isActive={frameSelected && frameSelected.id === frame.id}
                key={`frame-${i}`}
              />
            ) : (
              <></>
            )
          })}
      </ul>
    </div>
  )
}

export default FrameRow
